import React from "react";
import { getMessage } from "CONFIG/i18n";

// Components
import HeaderContainer from "COMPONENTS/Header/HeaderContainer";
import ChangeLanguage from "COMPONENTS/CommonComponents/ChangeLanguage/ChangeLanguage";

import { Row, Col, Button } from "reactstrap";
import "./StartSupportCenterSession.less";

const StartSupportCenterSession = (props) => {
  const description = props.description.map((item, index) => {
    return (
      <div key={"key" + index.toString()}>
        {item ? <>{item}</> : <br />}
      </div>
    );
  });

  return (
    <>
      <HeaderContainer />
      <div className="startSupportCenterSession">
        <section>
          <div className="languageSelection">
            <div className="mt-1">
              <ChangeLanguage
                onSelectChange={props.onChangeLanguage}
                language={props.language}
              />
            </div>
          </div>
          <div className="px-2">
            <div className="sessionImgArea col-12 col-xl-6 offset-xl-3 d-flex justify-content-center">
              <div className="col-4 p-0 d-flex flex-column">
                <Row className="noMargin">
                  <div className="text-center pt-5">
                  </div>
                </Row>
              </div>
            </div>
            <Row className="noMargin">
              <Col xs={12} md={12} className="text-center">
                <p></p>
              </Col>
            </Row>
            <div className="flexDirectionColumn noMarginForMobile inputForm inputFormForWaiting justifyContentFlexCenter alignItemsCenter mx-5">
              <span className="description">
                {description}
              </span>
              <span className="roundLoaderContainer">
                {props.shouldShowLoader && (
                  <div className="roundLoader"></div>
                )}
              </span>
              <br />
              {props.sessionName ? (
                <span className="sessionName">
                  {props.sessionName}
                </span>
              ) : null}
              {props.shouldShowCancel && (
                <>
                  <br />
                  <div className="permissionButtons">
                    <Button
                      className="buttons borderBtn bgwhite mr-2"
                      onClick={props.onCancelClick}
                    >
                      {getMessage("CANCEL")}
                    </Button>
                  </div>
                </>
              )}
              {props.errorMessage && (
                <div className="errorMessage pt-4">
                  {props.errorMessage}
                </div>
              )}
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default StartSupportCenterSession;
